// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"07748e57","977":"2c3e4923"}[chunkId] + ".chunk.js";
};